/** 전역 라이브러리 */
import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';

import { jwtDecode } from 'jwt-decode';
import find from 'lodash/find';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { useSetRecoilState } from 'recoil';

/** 전역 유틸리티 */
import { RoleTypes } from '@type/role';

import { ACCOUNT_ROLE } from '@constants/role';
import { auth } from '@constants/state';

import { create } from '@apis/api';

import {
  accessTokenStorage,
  expirationDateStorage,
} from '@src/storage/authStorage';

export function useLogin(
  setTemoporayModalOpen: Dispatch<SetStateAction<boolean>>
) {
  const navigate = useNavigate();
  const setAuth = useSetRecoilState(auth);

  const { mutate, isLoading } = useMutation(
    ['login'],
    (value: { division: string; email: string; password: string }) =>
      create('/login', value),
    {
      onSuccess: (res: any) => {
        if (res?.isError) {
          if (res?.data?.error === 'A003') {
            accessTokenStorage.clear();
            expirationDateStorage.clear();

            setAuth({
              isLogin: false,
              name: '',
              email: '',
              role: undefined,
              company: '',
              companyId: undefined,
            });
            toast.error('토큰이 만료되었습니다. 다시 로그인해주세요.');
          }
          toast.error(`${res?.data?.message} (${res?.data?.errorCode})`);
          console.error(
            `ERROR[${res?.data?.errorCode}] : ${res?.data?.message}`
          );
        } else {
          const {
            role,
            email,
            division,
            exp,
          }: {
            role: RoleTypes;
            email: string;
            division: string;
            exp: number;
          } = jwtDecode(res?.accessToken.replace('Bearer ', '')) ?? {
            role: undefined,
            email: '',
          };

          accessTokenStorage.set(res?.accessToken);
          expirationDateStorage.set(exp);

          setAuth({
            isLogin: true,
            name: role
              ? ['ROLE_MARK', 'ROLE_GOWID']?.includes(role)
                ? '슈퍼관리자'
                : role === 'ROLE_COMPANY'
                  ? '관리자'
                  : '참여자'
              : '참여자',
            company: role ? find(ACCOUNT_ROLE, { code: role })?.desc || '' : '',
            role: role,
            companyId: role
              ? ['ROLE_MARK', 'ROLE_GOWID'].includes(role)
                ? undefined
                : division
              : undefined,
            email,
          });

          res?.isTemporary
            ? setTemoporayModalOpen(true)
            : navigate('/', { replace: true });
          toast.success('로그인 되었습니다.');
        }
      },
    }
  );

  return { mutate, isLoading };
}
